import { ElMessage } from 'element-plus';
import { $t } from '@/plugins/i18n';
import axios from 'axios';
const versionCheck = async () => {
  const env = import.meta.env;
  const { VITE_PUBLIC_PATH, DEV } = env;
  const now = new Date().getTime();
  if (DEV) return;
  axios({
    method: 'get',
    url: `${VITE_PUBLIC_PATH}version.json?${now}`
  }).then(res => {
    if (res.data && __APP_INFO__.lastBuildTime !== res.data.version) {
      // eslint-disable-next-line no-undef
      ElMessage({
        message: $t('发现新内容，自动更新中...'),
        type: 'success',
        showClose: true,
        duration: 1500,
        onClose: () => {
          window.location.reload();
        }
      });
    }
  });
};

export default versionCheck;
